<template>
  <div>
    <v-menu ref="menu" :close-on-click="true" :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" small icon v-if="$vuetify.breakpoint.xs">
          <v-icon small> mdi-filter </v-icon>
        </v-btn>
        <v-btn v-else v-bind="attrs" v-on="on" flat color="primary">
          <v-icon left class="">mdi-filter-outline</v-icon> Lọc
        </v-btn></template
      >
      <v-sheet class="pa-4 filter-list">
        <autocomplete-room
          clearable
          :allRooms="allRooms"
          v-model="room"
          filled
          dense
          label="Phòng học"
          single-line
        ></autocomplete-room>
        <autocomplete-generation
          clearable
          :allGenerations="allGenerations"
          v-model="generation"
          item-text="code"
          item-value="id"
          filled
          dense
          label="Khóa sinh viên"
          single-line
        ></autocomplete-generation>
        <autocomplete-major
          clearable
          :allMajors="allMajors"
          v-model="major"
          item-text="title"
          item-value="id"
          filled
          dense
          label="Chuyên Ngành"
          single-line
        ></autocomplete-major>
        <autocomplete-course
          :allCourses="allCourses"
          filled
          clearable
          full-width
          single-line
          dense
          v-model="course"
        />
        <v-autocomplete
          full-width
          single-line
          label="Nhóm lớp"
          filled
          item-text="title"
          :items="allClasses"
          item-value="id"
          clearable
          dense
          v-model="slotClass"
        ></v-autocomplete>

        <autocomplete-teacher
          :allTeachers="allTeachers"
          v-model="teacher"
          item-text="name"
          item-value="id"
          label="Tên giảng viên"
          filled
          clearable
          full-width
          single-line
          dense
        />
        <v-select
          clearable
          item-text="label"
          item-value="value"
          :items="categoryItems"
          label="Loại buổi học"
          v-model="category"
          filled
          small
          :height="32"
        ></v-select>
        <div class="d-flex justify-space-between align-items">
          <v-btn v-bind="attrs" v-on="on" color="primary" @click="onFilterChanged"> Áp dụng </v-btn>
          <v-btn color="error" @click="clearFilter" icon title="Bỏ lọc">
            <v-icon> mdi-delete </v-icon>
          </v-btn>
        </div>
      </v-sheet>
    </v-menu>
  </div>
</template>

<script>
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher'
import AutocompleteCourse from '@/components/basic/input/AutocompleteCourse'
import AutocompleteMajor from '@/components/basic/input/AutocompleteMajor.vue'
import AutocompleteRoom from '@/components/basic/input/AutocompleteRoom.vue'
import AutocompleteGeneration from '@/components/basic/input/AutocompleteGeneration.vue'

export default {
  props: {
    allCourses: Array,
    allMajors: Array,
    allClasses: Array,
    allGenerations: Array,
    allTeachers: Array,
    allRooms: Array
  },
  components: {
    AutocompleteCourse,
    AutocompleteTeacher,
    AutocompleteMajor,
    AutocompleteRoom,
    AutocompleteGeneration
  },
  data: () => ({
    categoryItems: [
      { value: 'first', label: 'Buổi đầu' },
      { value: 'last', label: 'Buổi cuối' },
      { value: 'middle_exam', label: ' Buổi chấm giữa môn' }
    ],
    course: undefined,
    teacher: undefined,
    major: undefined,
    generation: undefined,
    slotClass: undefined,
    room: undefined,
    category: undefined
  }),
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        course: (this.course || {}).id,
        teacher: this.teacher,
        major: this.major,
        slotClass: this.slotClass,
        generation: this.generation,
        room: this.room,
        category: this.category
      })
      if (this.$refs.menu) {
        this.$refs.menu.save()
      }
    },
    clearFilter() {
      this.course = undefined
      this.major = undefined
      this.slotClass = undefined
      this.generation = undefined
      this.teacher = undefined
      this.room = undefined
      this.category = undefined
      this.$emit('onFilterChanged', {
        course: undefined,
        major: undefined,
        generation: undefined,
        slotClass: undefined,
        teacher: undefined,
        room: undefined,
        category: undefined
      })
    }
  }
}
</script>

<style scoped>
.filter-list {
  min-width: 200px;
  max-width: 300px;
}
</style>
